import { render, staticRenderFns } from "./MobileWhyProcessCompare.vue?vue&type=template&id=82b3996a&scoped=true"
import script from "./MobileWhyProcessCompare.vue?vue&type=script&lang=js"
export * from "./MobileWhyProcessCompare.vue?vue&type=script&lang=js"
import style0 from "./MobileWhyProcessCompare.vue?vue&type=style&index=0&id=82b3996a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b3996a",
  null
  
)

export default component.exports